
      import AliPayText from './ali-pay-text.vue'
      import type { App, Plugin } from 'vue'

      export const AliPayTextPlugin: Plugin = {
        install(app: App) {
          app.component('AliPayText', AliPayText)
        },
      }
      export { AliPayText }
      